import { graphql } from "@cappelendamm/crystallize-types/pim/gql";
export const GetSubscriptionItem = graphql(`
  query GetSubscriptionItem($sku: String!, $language: String!, $tenantId: ID!) {
    product {
      getVariants(skus: [$sku], language: $language, tenantId: $tenantId) {
        sku
        name
        components {
          componentId
          content {
            __typename
            ... on RichTextContent {
              json
              html
              plainText
            }
            ... on ContentChunkContent {
              chunks {
                componentId
                content {
                  __typename
                  ... on NumericContent {
                    __typename
                    number
                  }
                  ... on SingleLineContent {
                    __typename
                    text
                  }
                  ... on ItemRelationsContent {
                    ...relatedItem
                  }
                }
              }
            }
            ... on ItemRelationsContent {
              ...relatedItem
            }
            ... on BooleanContent {
              value
            }
            ... on SelectionContent {
              options {
                key
                value
              }
            }
          }
        }
        subscriptionPlans {
          identifier
          name
          periods {
            id
            name
            initial {
              ...pricing
            }
            recurring {
              ...pricing
            }
          }
        }
        product {
          __typename
          id
          name
          shape {
            identifier
          }
          topics {
            path
            name
            path
            ancestors {
              name
            }
          }
          components {
            name
            componentId
            content {
              __typename
              ... on ContentChunkContent {
                __typename
                chunks {
                  name
                  componentId
                  content {
                    ... on NumericContent {
                      __typename
                      number
                    }
                    ... on DatetimeContent {
                      __typename
                      datetime
                    }
                    ... on ItemRelationsContent {
                      ...relatedItem
                    }
                    ... on PieceContent {
                      __typename
                      identifier
                      components {
                        componentId
                        content {
                          __typename
                          ... on ContentChunkContent {
                            __typename
                            chunks {
                              componentId
                              name
                              content {
                                __typename
                                ... on ItemRelationsContent {
                                  ...relatedItem
                                }
                                ... on NumericContent {
                                  __typename
                                  number
                                }
                                ... on DatetimeContent {
                                  __typename
                                  datetime
                                }
                                ... on ContentChunkContent {
                                  __typename
                                  chunks {
                                    componentId
                                    name
                                    content {
                                      __typename
                                      ... on NumericContent {
                                        __typename
                                        number
                                      }
                                      ... on ItemRelationsContent {
                                        ...relatedItem
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                          ... on ItemRelationsContent {
                            ...relatedItem
                          }
                        }
                      }
                    }
                    ... on SingleLineContent {
                      __typename
                      text
                    }
                    ... on ImageContent {
                      __typename
                      images {
                        url
                        altText
                      }
                    }
                    ... on RichTextContent {
                      __typename
                      html
                    }
                  }
                }
              }
              ... on SingleLineContent {
                __typename
                text
              }
              ... on BooleanContent {
                __typename
                value
              }
              ... on SelectionContent {
                options {
                  key
                  value
                }
              }
              ... on ItemRelationsContent {
                __typename
                items {
                  name
                  components {
                    componentId
                    name
                    content {
                      ... on RichTextContent {
                        __typename
                        html
                        plainText
                      }
                      ... on SelectionContent {
                        __typename
                        options {
                          key
                          value
                        }
                      }
                      ... on SingleLineContent {
                        text
                      }
                      ... on ContentChunkContent {
                        __typename
                        chunks {
                          componentId
                          name
                          content {
                            __typename
                            ... on ItemRelationsContent {
                              ...relatedItem
                            }
                            ... on NumericContent {
                              __typename
                              number
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  fragment pricing on ProductVariantSubscriptionPlanPricing {
    period
    unit
    priceVariants {
      ...priceVariant
    }
    meteredVariables {
      id
      name
      identifier
      tierType
      tiers {
        threshold
        priceVariants {
          ...priceVariant
        }
      }
    }
  }

  fragment priceVariant on ProductPriceVariant {
    identifier
    price
    currency
  }

  fragment relatedItem on ItemRelationsContent {
    __typename
    items {
      __typename
      name
      ... on Product {
        name
        shape {
          identifier
        }
        defaultVariant {
          __typename
          sku
          name
          price
          priceVariants {
            identifier
            price
            currency
          }
          images {
            url
          }
          components {
            __typename
            name
            componentId
            content {
              __typename
              ... on NumericContent {
                number
              }
              ... on DatetimeContent {
                datetime
              }
              ... on BooleanContent {
                value
              }
            }
          }
        }
      }
    }
    productVariants {
      __typename
      sku
      name
      price
      product {
        shape {
          identifier
        }
        components {
          componentId
          content {
            ... on NumericContent {
              __typename
              number
            }
          }
        }
      }
      images {
        url
      }
      priceVariants {
        identifier
        price
        currency
      }
      components {
        __typename
        name
        componentId
        content {
          __typename
          ... on NumericContent {
            number
          }
          ... on DatetimeContent {
            datetime
          }
          ... on BooleanContent {
            value
          }
        }
      }
    }
  }
`);
